const Helper = {

	get_user_initials: function (user) {
		if (user && user.prenom && user.nom) {
			return user.prenom.substr(0, 1) + user.nom.substr(0, 1);
		}
		return "";
	},

};

export default Helper;